import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '../../lib/session';

/**
 * 路由守卫——前端呈现层面的默认拒绝（真正的强制点在后端，见 Spec §43）。
 * 未登录跳登录页；已登录但强制改密未完成时锁死到改密页，防止绕过。
 */
export function RequireAuth(): React.JSX.Element {
  const { data: session, isPending } = useSession();
  const location = useLocation();

  if (isPending) return <></>;
  if (session === null) return <Navigate to="/login" state={{ from: location }} replace />;
  if (session?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}
